<mat-toolbar class="subtitulo">Feriado</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">
        <div fxLayout="row" fxFlexFill>
            <mat-form-field fxLayoutGap="20px" fxFlex="80">
                <mat-label>Descrição</mat-label>
                <input #nome matInput maxlength="200" name="nome"
                       placeholder="Descrição" [(ngModel)]="feriado.descricao" required>
                <mat-hint align="end">{{ nome.value.length }} / 200</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="20" fxFlexOffset="20px">
                <mat-label>Data</mat-label>
                <input matInput name="data" [matDatepicker]="data" placeholder="Data"
                       [(ngModel)]="feriado.data" required (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="data"></mat-datepicker-toggle>
                <mat-datepicker #data></mat-datepicker>
            </mat-form-field>
        </div>

        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
                    name="botaoConfirmar"
                    fxFlex="20%"
                    color="primary"
                    [disabled]="formCadastro.invalid"
                    (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()"
                    mat-raised-button
                    fxFlex="20%"
                    (click)="limpar()">
                Limpar
            </button>
            <button
                    mat-raised-button
                    fxFlex="20%"
                    (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>


</div>






